import { Badge } from "@/components/ui/badge"
import type { EscalationReasonStatus } from "@/types/agent_escalation_reason"

const TONE = {
  pending:  "warning",
  live:     "success",
  archived: "neutral",
} as const

const LABEL: Record<EscalationReasonStatus, string> = {
  pending:  "Pending",
  live:     "Live",
  archived: "Archived",
}

export function EscalationReasonStatusBadge({ status }: { status: EscalationReasonStatus }) {
  return <Badge tone={TONE[status]}>{LABEL[status]}</Badge>
}
